import { createFileRoute } from '@tanstack/react-router';
import { buildHead } from '../../../../utils/seo';

export const Route = createFileRoute('/_layout/products/website-agent/')({
  head: () => buildHead('/products/website-agent'),
});

